module.exports = __webpack_public_path__ + "img/logo.e273a530.png";